import { SuccessfulConfirmController } from './successfulConfirm.controller';
import template from './successfulConfirm.html';

export const successfulConfirmComponent = {
  name: 'successfulConfirmComponent',
  restrict: 'E',
  template,
  controller: SuccessfulConfirmController,
  controllerAs: 'vm',
  bindings: {
    ticket: '<',
    stateIndex: '<'
  }
};
